import React from 'react';
import { ItemSection, ItemData } from './ItemSection';
const data: ItemData = {
  number: 3,
  title: "Chlorine Is an Oxidizer That Actively Raises Your Toddler's Skin pH (Destroying the Acidic Barrier That Protects Them)",
  mechanism: <>
      Healthy toddler skin maintains a pH of 4.5-5.5—acidic, which is
      protective. Chlorine is an oxidizing agent that{' '}
      <strong data-id="element-138">chemically raises pH</strong> toward neutral/alkaline. When pH
      rises, the skin's natural protective barrier (made of lipids and amino
      acids) <strong data-id="element-139">begins breaking down</strong>. This isn't a temporary
      irritation—it's <strong data-id="element-140">active chemical disruption</strong>. The skin is
      literally being <strong data-id="element-141">chemically altered</strong> during the shower.
    </>,
  avatars: {
    jessica: <>
        This is why even premium products seem to{' '}
        <strong data-id="element-142">stop working over time</strong>. You're working against{' '}
        <strong data-id="element-143">active pH disruption</strong>, not managing a static condition.
      </>,
    michelle: <>
        This is the mechanism that separates water quality from all other health
        variables. Without addressing the source,{' '}
        <strong data-id="element-144">nothing else compounds</strong>.
      </>
  },
  bridge: <>
      Creams can restore pH temporarily, but they{' '}
      <strong data-id="element-145">can't maintain it</strong> against{' '}
      <strong data-id="element-146">daily chlorine exposure</strong>.
    </>,
  image: {
    url: 'https://images.unsplash.com/photo-1532094349884-543bc11b234d?w=800&q=80',
    alt: "pH scale diagram showing color gradient from blue (healthy acidic pH 4.5-5.5) to red (damaged alkaline pH), illustrating chlorine's effect on skin pH"
  },
  imageOnLeft: false
};
export function Item3Section() {
  return <ItemSection data={data} data-id="element-147" />;
}